var _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconZeroActivity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 0.5C46.2924 0.5 59.5 13.7076 59.5 30C59.5 46.2924 46.2924 59.5 30 59.5C13.7076 59.5 0.5 46.2924 0.5 30C0.5 13.7076 13.7076 0.5 30 0.5Z",
    stroke: "url(#paint0_linear_18_2541)",
    strokeOpacity: 0.41
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14258 30.0001C5.14258 16.2719 16.2715 5.14294 29.9997 5.14294C43.7279 5.14294 54.8569 16.2719 54.8569 30.0001C54.8569 43.7283 43.7279 54.8572 29.9997 54.8572C16.2715 54.8572 5.14258 43.7283 5.14258 30.0001Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5.64294C43.4519 5.6431 54.3564 16.5484 54.3564 30.0004C54.3563 43.4522 43.4519 54.3567 30 54.3568C16.548 54.3568 5.64273 43.4523 5.64258 30.0004C5.64258 16.5483 16.5479 5.64294 30 5.64294Z",
    stroke: "url(#paint1_linear_18_2541)",
    strokeOpacity: 0.41
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2541)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 30,
    height: 30
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15H15V45H45V15Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3 17.5H24.7C21.25 17.5 20 18.75 20 22.2625V37.7375C20 41.25 21.25 42.5 24.7 42.5H35.2875C38.75 42.5 40 41.25 40 37.7375V22.2625C40 18.75 38.75 17.5 35.3 17.5ZM30 39.125C28.8 39.125 27.8125 38.1375 27.8125 36.9375C27.8125 35.7375 28.8 34.75 30 34.75C31.2 34.75 32.1875 35.7375 32.1875 36.9375C32.1875 38.1375 31.2 39.125 30 39.125ZM32.5 22.8125H27.5C26.9875 22.8125 26.5625 22.3875 26.5625 21.875C26.5625 21.3625 26.9875 20.9375 27.5 20.9375H32.5C33.0125 20.9375 33.4375 21.3625 33.4375 21.875C33.4375 22.3875 33.0125 22.8125 32.5 22.8125Z",
    fill: "#34D399",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 41.8749L40.1594 17.5423",
    stroke: "#34D399",
    strokeWidth: 3,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2541",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2541",
    x1: 29.9997,
    y1: 5.14294,
    x2: 29.9997,
    y2: 54.8572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZeroActivity);
export default __webpack_public_path__ + "static/media/icon-zero-activity.959d08cad20e735430c89b08a8693819.svg";
export { ForwardRef as ReactComponent };